import { NgModule } from "@angular/core";
import { NouisliderModule } from "ng2-nouislider";
import { SearchResultsComponent } from "apps-module/app/entry-modules/event-search/components/search-results/search-results.component";
import { ResultItemComponent } from "apps-module/app/entry-modules/event-search/components/search-results/result-item/result-item.component";
import { EventSearchComponent } from "apps-module/app/entry-modules/event-search/event-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { SearchMessageComponent } from "apps-module/app/entry-modules/event-search/components/search-message/search-message.component";
import { DateFilterComponent } from "apps-module/app/entry-modules/event-search/components/date-filter/date-filter.component";

@NgModule({
    declarations: [
        SearchMessageComponent,
        DateFilterComponent,
        EventSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [EventSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class EventSearchModule { }
